// @ts-nocheck
import React from 'react';
import SensorsRoundedIcon from "@mui/icons-material/SensorsRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { RiHomeLine } from "react-icons/ri";
import { TbCheckbox } from "react-icons/tb";
import { TbCalendar } from "react-icons/tb";
import { RiFileShieldLine } from "react-icons/ri";
const IconList = [
    {
        id:101,
        icon:<RiHomeLine aria-label="home-svg" style={{width:"24px",height:"24px",color:"#3B3B3B",fontWeight:"bold"}}/>, //MyBid
    },
    {
        id:102,
        icon:<SensorsRoundedIcon aria-label="liveauction-svg" style={{width:"24px",height:"24px"}}/>, //LiveAuction
    },
    {
        id:103,
        icon:<SearchRoundedIcon aria-label="search-svg" style={{width:"24px",height:"24px"}}/> //Search
    },
    {
        id:104,
        icon:<CalendarMonthOutlinedIcon aria-label="calendar-svg" style={{color:"#3B3B3B",width:"24px",height:"24px"}}/> //Auction Calendar
    },
    {
        id:105,
        icon:<AccountBalanceWalletOutlinedIcon aria-label="account-svg" style={{width:"24px",height:"24px"}}/> //Manage Funds
    },
    {
        id:106,
        icon:<FavoriteBorderIcon aria-label="favourite-svg" style={{width:"24px",height:"24px"}}/> //Favorites
    },
    {
        id:107,
        icon:<KeyboardArrowDownIcon/>,
        iconOpen:<ChevronRightIcon/> //More
    },
    {
        id:108,
        icon:<AccountCircleOutlinedIcon aria-label="circle-svg" style={{width:"24px",height:"24px"}}/>  //More
    },    
    {
        id:109,
        icon:<PersonAddAltIcon aria-label="PersonAddAltIcon-svg" style={{width:"24px",height:"24px"}}/> //MyProfile
    },
    {
        id:110,
        icon:<TbCheckbox aria-label="tbcheck-svg" style={{width:"24px",height:"24px",color:"#3B3B3B", fontWeight:"bold"}}/>  //Purchare Profile
    },
    {
        id:111,
        icon:<RiFileShieldLine aria-label="rifileshield-svg" style={{width:"24px",height:"24px",color:"#3B3B3B", fontWeight:"bold"}}/>
    }
]

export default IconList